export const DefaultOptions = {
  tabWidth: 2,
  useTabs: false
}

export default function stringifyJSObject(input, options, pad) {
  const {tabWidth, useTabs} = {...DefaultOptions, ...options}
  const indent = useTabs ? '\t' : ' '.repeat(tabWidth)

  const seen = []
  return (function stringify(input = {}, pad = '') {
    let tokens = {
      newline: '\n',
      newlineOrSpace: '\n',
      pad,
      indent: pad + indent,
    }

    if (seen.includes(input)) {
      return '"[Circular]"'
    }

    if (
      input === null
      || input === undefined
      || typeof input === 'number'
      || typeof input === 'boolean'
      || typeof input === 'function'
      || typeof input === 'symbol'
      || isRegexp(input)
    ) {
      return String(input)
    }

    if (input instanceof Date) {
      return `new Date('${input.toISOString()}')`
    }

    if (Array.isArray(input)) {
      if (input.length === 0) {
        return '[]'
      }

      seen.push(input)

      const returnValue = '[' + tokens.newline + input.map((element, i) => {
        const eol = input.length - 1 === i ? tokens.newline : ',' + tokens.newlineOrSpace

        let value = stringify(element, pad + indent)

        return tokens.indent + value + eol
      }).join('') + tokens.pad + ']'

      seen.pop()

      return returnValue
    }

    if (isObject(input)) {
      let objectKeys = [
        ...Object.keys(input),
        ...getOwnEnumPropSymbols(input),
      ]

      if (objectKeys.length === 0) {
        return '{}'
      }

      seen.push(input)

      const returnValue = '{' + tokens.newline + objectKeys.map((element, i) => {
        const eol = objectKeys.length - 1 === i ? tokens.newline : ',' + tokens.newlineOrSpace
        const isSymbol = typeof element === 'symbol'
        const isClassic = !isSymbol && /^[a-z$_][$\w]*$/i.test(element)
        const key = isSymbol || isClassic ? element : stringify(element)

        let value = stringify(input[element], pad + indent)

        return tokens.indent + String(key) + ': ' + value + eol
      }).join('') + tokens.pad + '}'

      seen.pop()

      return returnValue
    }

    input = input.replace(/\\/g, '\\\\')
    input = String(input).replace(/[\r\n]/g, x => x === '\n' ? '\\n' : '\\r')

    input = input.replace(/'/g, '\\\'')
    return `'${input}'`
  })(input, pad)
}

function isObject(value) {
  const type = typeof value
  return value !== null && (type === 'object' || type === 'function')
}

function getOwnEnumPropSymbols(object) {
  return Object.getOwnPropertySymbols(object)
    .filter((keySymbol) => Object.prototype.propertyIsEnumerable.call(object, keySymbol))
}

function isRegexp(value) {
  return Object.prototype.toString.call(value) === '[object RegExp]'
}
